import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { TermsAcceptanceProvider } from "./lib/termsAcceptanceContext.jsx";
import { WalletAuthProvider } from "./lib/walletAuth";
import "./styles.css";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <WalletAuthProvider>
      <BrowserRouter>
        <TermsAcceptanceProvider>
          <App />
        </TermsAcceptanceProvider>
      </BrowserRouter>
    </WalletAuthProvider>
  </React.StrictMode>
);
